import { withInternetuLegacySlugs } from '@/lib/calculatorSlugs.mjs';

/** Canonical home / real-estate calculator slug (coming-soon notice). */
export const HOME_INSURANCE_SLUG = 'nekilnojamo-turto-draudimas-internetu';

/**
 * SEO landing URLs that reuse the same home coming-soon page.
 * Only URL + marketing texts differ.
 */
export const HOME_LANDING_SLUGS = [
  'sodo-namo-draudimas-internetu',
  'namu-vidaus-turto-draudimas-internetu',
  'namo-draudimas-internetu',
  'buto-draudimas-internetu',
  'kotedzo-draudimas-internetu',
];

const HOME_FLOW_SLUGS = withInternetuLegacySlugs([
  HOME_INSURANCE_SLUG,
  ...HOME_LANDING_SLUGS,
]);
const HOME_LANDING_FLOW_SLUGS = withInternetuLegacySlugs(HOME_LANDING_SLUGS);

export function isHomeInsuranceSlug(slug) {
  return HOME_FLOW_SLUGS.has(slug);
}

export function isHomeLandingSlug(slug) {
  return HOME_LANDING_FLOW_SLUGS.has(slug);
}
